import {
    Box,
    Button,
    Flex, Heading, ListItem, OrderedList, Text,
} from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';
import { ImageContentLayout } from '../layouts';
import { ErrorCodeBlock } from '../components/errors';

export function AppError({ error }: { error?: Error }): ReactElement {
    const sessionId = datadogRum.getInternalContext()?.session_id;

    // eslint-disable-next-line no-console
    console.error({
        sessionId,
        error,
    });

    return (
        <ImageContentLayout>
            <Flex flexDir="column" alignItems="start">
                <Heading fontSize="3xl" mb={4}>
                    Something went wrong
                </Heading>
                {
                    import.meta.env.VITE_PUBLIC_ENVIRONMENT !== 'production' ? (
                        <Box py={6} w="100%" fontSize="sm">
                            <ErrorCodeBlock error={error} sessionId={sessionId} />
                        </Box>
                    ) : (
                        <>
                            <Text fontSize="lg" mb={4}>
                                There are a few reasons why this page is not loading correctly:
                            </Text>
                            <OrderedList spacing={2} py={4}>
                                <ListItem>
                                    <Text>
                                        Part of our application has been removed or relocated and
                                        isn&apos;t loading correctly.
                                    </Text>
                                </ListItem>
                                <ListItem>
                                    <Text>
                                        The URL has been entered incorrectly.
                                    </Text>
                                </ListItem>
                            </OrderedList>
                            <Text mb={4}>
                                If you have an account, we recommend logging in to your account and
                                trying again. If the matter persists, please feel free to call us
                                and speak to one of our staff.
                            </Text>
                        </>
                    )
                }
                <Button as={Link} to="/auth/login" mt={6} variant="rounded-solid" size="cta-md" colorScheme="primary">
                    Try logging in again
                </Button>
            </Flex>
        </ImageContentLayout>
    );
}
